import { render, staticRenderFns } from "./Emergency.vue?vue&type=template&id=97ff1ba4&scoped=true"
import script from "./Emergency.vue?vue&type=script&lang=js"
export * from "./Emergency.vue?vue&type=script&lang=js"
import style0 from "./Emergency.vue?vue&type=style&index=0&id=97ff1ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff1ba4",
  null
  
)

export default component.exports